<div class="chart" #svgContainer></div>
